import webApi from "@/services/api"

export class CustomerDetailService {
    carDetail(data) {
        return webApi.post('car-detail', data)
    }
    getPriceRange(params) {
        return webApi.get('car-detail/price-range-process/car-info-redbook-october/autoflip', { params })
    }
    getListLocations() {
        return webApi.get('location-service')
    }
    resolveDomain(domain) {
        return webApi.get('dns-validation-service/resolve', { params: { domain } })
    }
    initCarDetails(data) {
        return webApi.post('car-detail/init-car-details', data)
    }
    getAppraisalId(id, config = {}) {
        return webApi.get('car-detail/get-appraisal-id', {
            params: { id },
            ...config
        });
    }
    updatePSPDataLogsWithAction(data) {
        return webApi.post('car-detail/update-psp-logs-with-action', data)
    }
}

const customerDetailService = new CustomerDetailService()

export default customerDetailService
